<script lang="ts">
  interface Props {
    size?: number;
    [key: string]: any;
  }

  let { size = 16, ...rest }: Props = $props();
</script>

<svg
  width={size}
  height={size}
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  {...rest}
>
  <path
    d="M1.74994 6.75L6.74994 1.75C7.71644 0.783503 9.28344 0.783502 10.2499 1.75C11.2164 2.7165 11.2164 4.2835 10.2499 5.25L6.99994 8.5"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="bevel"
  />
  <path
    d="M8.49994 3.5L5.24994 6.75C4.28344 7.7165 4.28344 9.2835 5.24994 10.25C6.21644 11.2165 7.78344 11.2165 8.74994 10.25L11.9999 7"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="bevel"
  />
  <path
    d="M9.21961 15.2803C9.5125 15.5732 9.98738 15.5732 10.2803 15.2803C10.5732 14.9874 10.5732 14.5126 10.2803 14.2197L9.74994 14.75L9.21961 15.2803ZM9.36358 13.1364L8.83325 12.606L9.36358 13.1364ZM9.36358 14.3636L9.89391 13.8333L9.36358 14.3636ZM6.99994 8.5L7.53027 9.03033L10.7803 5.78033L10.2499 5.25L9.71961 4.71967L6.46961 7.96967L6.99994 8.5ZM13.7499 8.75L13.2196 8.21967L8.83325 12.606L9.36358 13.1364L9.89391 13.6667L14.2803 9.28033L13.7499 8.75ZM9.36358 14.3636L8.83325 14.894L9.21961 15.2803L9.74994 14.75L10.2803 14.2197L9.89391 13.8333L9.36358 14.3636ZM9.36358 13.1364L8.83325 12.606C8.20145 13.2378 8.20145 14.2622 8.83325 14.894L9.36358 14.3636L9.89391 13.8333C9.8479 13.7873 9.8479 13.7127 9.89391 13.6667L9.36358 13.1364ZM13.7499 5.25L13.2196 5.78033C13.8932 6.45394 13.8932 7.54606 13.2196 8.21967L13.7499 8.75L14.2803 9.28033C15.5397 8.02094 15.5397 5.97906 14.2803 4.71967L13.7499 5.25ZM10.2499 5.25L10.7803 5.78033C11.4539 5.10672 12.546 5.10672 13.2196 5.78033L13.7499 5.25L14.2803 4.71967C13.0209 3.46028 10.979 3.46028 9.71961 4.71967L10.2499 5.25Z"
    fill="currentColor"
  />
</svg>
